// Module
var code = "<div id=\"graphscontainer\" class=\"flexcol\"></div> <table id=\"qcfiletable\" class=\"selectable\"> <thead> <tr> <th width=\"50\" title=\"Out of range status\">&#9888</th> <th>File</th> <th>Lot #</th> <th>Material</th> <th>Expiry Date</th> <th>Analysis Date</th> </tr> </thead> </table>";
// Exports
export default code;